import Vuex from 'vuex'
import Vue from 'vue'

import actions from './actions'
import getters from './getters'
import mutations from './mutations'

Vue.use(Vuex)

const store = new Vuex.Store({
  strict: true,
  state: {
    progress: 0,
    err_score: 0,
    window_h: 0,
    window_w: 0,
    angles_origin: ['a1So', 'a1Lo', 'b1So', 'b1Lo', 'a2So', 'a2Lo', 'b2So', 'b2Lo', 'a3So', 'a3Lo', 'b3So', 'b3Lo', 'a4So', 'a4Lo', 'a5So', 'a5Lo', 'a1Sx', 'a1Lx', 'a2Sx', 'a2Lx', 'a3Sx', 'a3Lx', 'a4Sx', 'a4Lx', 'a5Sx', 'a5Lx'],
    angles: ['a1So', 'a1Lo', 'b1So', 'b1Lo', 'a2So', 'a2Lo', 'b2So', 'b2Lo', 'a3So', 'a3Lo', 'b3So', 'b3Lo', 'a4So', 'a4Lo', 'a5So', 'a5Lo', 'a1Sx', 'a1Lx', 'a2Sx', 'a2Lx', 'a3Sx', 'a3Lx', 'a4Sx', 'a4Lx', 'a5Sx', 'a5Lx'],
    ends: {
      same: {
        a1So: {
          score: 0,
          left: {
            top: 100,
            left: 100,
            height: 200,
            shape: {
              line: 'strong_a',
              upper: {
                angle: 'down',
                top: 61,
                left: 88
              },
              lower: {
                angle: 'up',
                top: 298,
                left: 112
              }
            }
          },
          right: {
            top: 120,
            left: 500,
            height: 240,
            shape: {
              line: 'strong_a',
              upper: {
                angle: 'down',
                top: 76,
                left: 478
              },
              lower: {
                angle: 'up',
                top: 359,
                left: 502
              }
            }
          }
        },
        a1Lo: {
          score: 0,
          left: {
            top: 60,
            left: 100,
            height: 260,
            shape: {
              line: 'strong_a',
              upper: {
                angle: 'down',
                top: 16,
                left: 78
              },
              lower: {
                angle: 'up',
                top: 319,
                left: 102
              }
            }
          },
          right: {
            top: 100,
            left: 500,
            height: 180,
            shape: {
              line: 'strong_a',
              upper: {
                angle: 'down',
                top: 56,
                left: 493
              },
              lower: {
                angle: 'up',
                top: 279,
                left: 517
              }
            }
          }
        },
        b1So: {
          score: 0,
          left: {
            top: 150,
            left: 100,
            height: 140,
            shape: {
              line: 'strong_b',
              upper: {
                angle: 'up',
                top: 144,
                left: 92
              },
              lower: {
                angle: 'down',
                top: 251,
                left: 68
              }
            }
          },
          right: {
            top: 120,
            left: 500,
            height: 210,
            shape: {
              line: 'strong_b',
              upper: {
                angle: 'up',
                top: 114,
                left: 502
              },
              lower: {
                angle: 'down',
                top: 291,
                left: 478
              }
            }
          }
        },
        b1Lo: {
          score: 0,
          left: {
            top: 150,
            left: 100,
            height: 255,
            shape: {
              line: 'strong_b',
              upper: {
                angle: 'up',
                top: 144,
                left: 102
              },
              lower: {
                angle: 'down',
                top: 367,
                left: 78
              }
            }
          },
          right: {
            top: 70,
            left: 500,
            height: 100,
            shape: {
              line: 'strong_b',
              upper: {
                angle: 'up',
                top: 64,
                left: 482
              },
              lower: {
                angle: 'down',
                top: 131,
                left: 458
              }
            }
          }
        },
        a2So: {
          score: 0,
          left: {
            top: 150,
            left: 100,
            height: 105,
            shape: {
              line: 'medium_a',
              upper: {
                angle: 'down',
                top: 117,
                left: 98
              },
              lower: {
                angle: 'up',
                top: 255,
                left: 132
              }
            }
          },
          right: {
            top: 120,
            left: 500,
            height: 220,
            shape: {
              line: 'medium_a',
              upper: {
                angle: 'down',
                top: 85,
                left: 433
              },
              lower: {
                angle: 'up',
                top: 339,
                left: 467
              }
            }
          }
        },
        a2Lo: {
          score: 0,
          left: {
            top: 120,
            left: 100,
            height: 255,
            shape: {
              line: 'medium_a',
              upper: {
                angle: 'down',
                top: 120 - 32,
                left: 100 - 33
              },
              lower: {
                angle: 'up',
                top: 255 + 120,
                left: 100 + 2
              }
            }
          },
          right: {
            top: 120,
            left: 500,
            height: 210,
            shape: {
              line: 'medium_a',
              upper: {
                angle: 'down',
                top: 115,
                left: 467
              },
              lower: {
                angle: 'up',
                top: 265,
                left: 467
              }
            }
          }
        },
        b2So: {
          score: 0,
          left: {
            top: 150,
            left: 100,
            height: 105,
            shape: {
              line: 'medium_b',
              upper: {
                angle: 'up',
                top: 145,
                left: 67
              },
              lower: {
                angle: 'down',
                top: 190,
                left: 67
              }
            }
          },
          right: {
            top: 120,
            left: 500,
            height: 210,
            shape: {
              line: 'medium_b',
              upper: {
                angle: 'up',
                top: 115,
                left: 467
              },
              lower: {
                angle: 'down',
                top: 265,
                left: 467
              }
            }
          }
        },
        b2Lo: {
          score: 0,
          left: {
            top: 150,
            left: 100,
            height: 105,
            shape: {
              line: 'medium_b',
              upper: {
                angle: 'up',
                top: 145,
                left: 67
              },
              lower: {
                angle: 'down',
                top: 190,
                left: 67
              }
            }
          },
          right: {
            top: 120,
            left: 500,
            height: 210,
            shape: {
              line: 'medium_b',
              upper: {
                angle: 'up',
                top: 115,
                left: 467
              },
              lower: {
                angle: 'down',
                top: 265,
                left: 467
              }
            }
          }
        },
        a3So: {
          score: 0,
          left: {
            top: 150,
            left: 100,
            height: 105,
            shape: {
              line: 'weak_a',
              upper: {
                angle: 'down',
                top: 145,
                left: 67
              },
              lower: {
                angle: 'up',
                top: 190,
                left: 67
              }
            }
          },
          right: {
            top: 120,
            left: 500,
            height: 210,
            shape: {
              line: 'weak_a',
              upper: {
                angle: 'down',
                top: 115,
                left: 467
              },
              lower: {
                angle: 'up',
                top: 265,
                left: 467
              }
            }
          }
        },
        a3Lo: {
          score: 0,
          left: {
            top: 150,
            left: 100,
            height: 105,
            shape: {
              line: 'weak_a',
              upper: {
                angle: 'down',
                top: 145,
                left: 67
              },
              lower: {
                angle: 'up',
                top: 190,
                left: 67
              }
            }
          },
          right: {
            top: 120,
            left: 500,
            height: 210,
            shape: {
              line: 'weak_a',
              upper: {
                angle: 'down',
                top: 115,
                left: 467
              },
              lower: {
                angle: 'up',
                top: 265,
                left: 467
              }
            }
          }
        },
        b3So: {
          score: 0,
          left: {
            top: 150,
            left: 100,
            height: 105,
            shape: {
              line: 'weak_b',
              upper: {
                angle: 'up',
                top: 145,
                left: 67
              },
              lower: {
                angle: 'down',
                top: 190,
                left: 67
              }
            }
          },
          right: {
            top: 120,
            left: 500,
            height: 210,
            shape: {
              line: 'weak_b',
              upper: {
                angle: 'up',
                top: 115,
                left: 467
              },
              lower: {
                angle: 'down',
                top: 265,
                left: 467
              }
            }
          }
        },
        b3Lo: {
          score: 0,
          left: {
            top: 150,
            left: 100,
            height: 105,
            shape: {
              line: 'weak_b',
              upper: {
                angle: 'up',
                top: 145,
                left: 67
              },
              lower: {
                angle: 'down',
                top: 190,
                left: 67
              }
            }
          },
          right: {
            top: 120,
            left: 500,
            height: 210,
            shape: {
              line: 'weak_b',
              upper: {
                angle: 'up',
                top: 115,
                left: 467
              },
              lower: {
                angle: 'down',
                top: 265,
                left: 467
              }
            }
          }
        },
        a4So: {
          score: 0,
          left: {
            top: 150,
            left: 100,
            height: 105,
            shape: {
              line: 'horizontal',
              upper: {
                angle: 'up',
                top: 145,
                left: 67
              },
              lower: {
                angle: 'down',
                top: 190,
                left: 67
              }
            }
          },
          right: {
            top: 120,
            left: 500,
            height: 210,
            shape: {
              line: 'horizontal',
              upper: {
                angle: 'up',
                top: 115,
                left: 467
              },
              lower: {
                angle: 'down',
                top: 265,
                left: 467
              }
            }
          }
        },
        a4Lo: {
          score: 0,
          left: {
            top: 150,
            left: 100,
            height: 105,
            shape: {
              line: 'horizontal',
              upper: {
                angle: 'up',
                top: 145,
                left: 67
              },
              lower: {
                angle: 'down',
                top: 190,
                left: 67
              }
            }
          },
          right: {
            top: 120,
            left: 500,
            height: 210,
            shape: {
              line: 'horizontal',
              upper: {
                angle: 'up',
                top: 115,
                left: 467
              },
              lower: {
                angle: 'down',
                top: 265,
                left: 467
              }
            }
          }
        },
        a5So: {
          score: 0,
          left: {
            top: 150,
            left: 100,
            height: 105,
            shape: {
              line: 'circle_a',
              upper: {
                angle: 'up',
                top: 145,
                left: 67
              },
              lower: {
                angle: 'down',
                top: 190,
                left: 67
              }
            }
          },
          right: {
            top: 120,
            left: 500,
            height: 210,
            shape: {
              line: 'circle_a',
              upper: {
                angle: 'up',
                top: 115,
                left: 467
              },
              lower: {
                angle: 'down',
                top: 265,
                left: 467
              }
            }
          }
        },
        a5Lo: {
          score: 0,
          left: {
            top: 150,
            left: 100,
            height: 105,
            shape: {
              line: 'circle_a',
              upper: {
                angle: 'up',
                top: 145,
                left: 67
              },
              lower: {
                angle: 'down',
                top: 190,
                left: 67
              }
            }
          },
          right: {
            top: 120,
            left: 500,
            height: 210,
            shape: {
              line: 'circle_a',
              upper: {
                angle: 'up',
                top: 115,
                left: 467
              },
              lower: {
                angle: 'down',
                top: 265,
                left: 467
              }
            }
          }
        }
      },
      conflict: {
        a1Sx: {
          score: 0,
          left: {
            top: 150,
            left: 100,
            height: 105,
            shape: {
              line: 'strong_a',
              upper: {
                angle: 'up',
                top: 145,
                left: 67
              },
              lower: {
                angle: 'down',
                top: 190,
                left: 67
              }
            }
          },
          right: {
            top: 120,
            left: 500,
            height: 210,
            shape: {
              line: 'strong_b',
              upper: {
                angle: 'up',
                top: 115,
                left: 467
              },
              lower: {
                angle: 'down',
                top: 265,
                left: 467
              }
            }
          }
        },
        a1Lx: {
          score: 0,
          left: {
            top: 150,
            left: 100,
            height: 105,
            shape: {
              line: 'strong_a',
              upper: {
                angle: 'up',
                top: 145,
                left: 67
              },
              lower: {
                angle: 'down',
                top: 190,
                left: 67
              }
            }
          },
          right: {
            top: 120,
            left: 500,
            height: 210,
            shape: {
              line: 'strong_b',
              upper: {
                angle: 'up',
                top: 115,
                left: 467
              },
              lower: {
                angle: 'down',
                top: 265,
                left: 467
              }
            }
          }
        },
        a2Sx: {
          score: 0,
          left: {
            top: 150,
            left: 100,
            height: 105,
            shape: {
              line: 'medium_a',
              upper: {
                angle: 'up',
                top: 145,
                left: 67
              },
              lower: {
                angle: 'down',
                top: 190,
                left: 67
              }
            }
          },
          right: {
            top: 120,
            left: 500,
            height: 210,
            shape: {
              line: 'medium_b',
              upper: {
                angle: 'up',
                top: 115,
                left: 467
              },
              lower: {
                angle: 'down',
                top: 265,
                left: 467
              }
            }
          }
        },
        a2Lx: {
          score: 0,
          left: {
            top: 150,
            left: 100,
            height: 105,
            shape: {
              line: 'medium_a',
              upper: {
                angle: 'up',
                top: 145,
                left: 67
              },
              lower: {
                angle: 'down',
                top: 190,
                left: 67
              }
            }
          },
          right: {
            top: 120,
            left: 500,
            height: 210,
            shape: {
              line: 'medium_b',
              upper: {
                angle: 'up',
                top: 115,
                left: 467
              },
              lower: {
                angle: 'down',
                top: 265,
                left: 467
              }
            }
          }
        },
        a3Sx: {
          score: 0,
          left: {
            top: 150,
            left: 100,
            height: 105,
            shape: {
              line: 'weak_a',
              upper: {
                angle: 'up',
                top: 145,
                left: 67
              },
              lower: {
                angle: 'down',
                top: 190,
                left: 67
              }
            }
          },
          right: {
            top: 120,
            left: 500,
            height: 210,
            shape: {
              line: 'weak_b',
              upper: {
                angle: 'up',
                top: 115,
                left: 467
              },
              lower: {
                angle: 'down',
                top: 265,
                left: 467
              }
            }
          }
        },
        a3Lx: {
          score: 0,
          left: {
            top: 150,
            left: 100,
            height: 105,
            shape: {
              line: 'weak_a',
              upper: {
                angle: 'up',
                top: 145,
                left: 67
              },
              lower: {
                angle: 'down',
                top: 190,
                left: 67
              }
            }
          },
          right: {
            top: 120,
            left: 500,
            height: 210,
            shape: {
              line: 'weak_b',
              upper: {
                angle: 'up',
                top: 115,
                left: 467
              },
              lower: {
                angle: 'down',
                top: 265,
                left: 467
              }
            }
          }
        },
        a4Sx: {
          score: 0,
          left: {
            top: 150,
            left: 100,
            height: 105,
            shape: {
              line: 'horizontal',
              upper: {
                angle: 'up',
                top: 145,
                left: 67
              },
              lower: {
                angle: 'down',
                top: 190,
                left: 67
              }
            }
          },
          right: {
            top: 120,
            left: 500,
            height: 210,
            shape: {
              line: 'none',
              upper: {
                angle: '0',
                top: 115,
                left: 467
              },
              lower: {
                angle: '0',
                top: 265,
                left: 467
              }
            }
          }
        },
        a4Lx: {
          score: 0,
          left: {
            top: 150,
            left: 100,
            height: 105,
            shape: {
              line: 'horizontal',
              upper: {
                angle: 'up',
                top: 145,
                left: 67
              },
              lower: {
                angle: 'down',
                top: 190,
                left: 67
              }
            }
          },
          right: {
            top: 120,
            left: 500,
            height: 210,
            shape: {
              line: 'none',
              upper: {
                angle: '0',
                top: 115,
                left: 467
              },
              lower: {
                angle: '0',
                top: 265,
                left: 467
              }
            }
          }
        },
        a5Sx: {
          score: 0,
          left: {
            top: 150,
            left: 100,
            height: 105,
            shape: {
              line: 'circle_b',
              upper: {
                angle: 'up',
                top: 145,
                left: 67
              },
              lower: {
                angle: 'down',
                top: 190,
                left: 67
              }
            }
          },
          right: {
            top: 120,
            left: 500,
            height: 210,
            shape: {
              line: 'circle_a',
              upper: {
                angle: 'up',
                top: 115,
                left: 467
              },
              lower: {
                angle: 'down',
                top: 265,
                left: 467
              }
            }
          }
        },
        a5Lx: {
          score: 0,
          left: {
            top: 150,
            left: 100,
            height: 105,
            shape: {
              line: 'circle_b',
              upper: {
                angle: 'up',
                top: 145,
                left: 67
              },
              lower: {
                angle: 'down',
                top: 190,
                left: 67
              }
            }
          },
          right: {
            top: 120,
            left: 500,
            height: 210,
            shape: {
              line: 'circle_a',
              upper: {
                angle: 'up',
                top: 115,
                left: 467
              },
              lower: {
                angle: 'down',
                top: 265,
                left: 467
              }
            }
          }
        }
      }
    }
  },
  actions,
  getters,
  mutations
})

export default store
